export default "__VITE_ASSET__DnC7ry06__"